import { tw } from "../../styling/helpers";
import type { ColSpan } from "../../styling/theme";

export type MaybeResponsive<T> = T | { base: T; tablet?: T; desktop?: T; laptop?: T };

type Props = {
	span: MaybeResponsive<ColSpan>;
	children: React.ReactNode;
};

export const Col = ({ span, children }: Props) => {
	if (typeof span === "number") {
		return <div className={`basis-${span}/12`}>{children}</div>;
	}

	const classes = Object.entries(span).map(([size, span]) =>
		size === "base" ? `basis-${span}/12` : `${size}:basis-${span}/12`,
	);

	return (
		<div className={tw("p-2", ...classes)}>
			<div>{children}</div>
		</div>
	);
};
